import Vue from 'vue';

// Arep Ui
import ARStyle from '@audience-republic/arep-ui/dist/plugins/ar-style';
// import ARNotification from 'arep-ui/dist/plugins/ARNotification';
import ARMediaQuery from '@audience-republic/arep-ui/dist/plugins/ar-media-query';
import ARBrowser from '@audience-republic/arep-ui/dist/plugins/ar-browser';
import ARIcon from '@audience-republic/arep-ui/dist/components/ARIcon';
import ARFlagIcon from '@audience-republic/arep-ui/dist/components/ARFlagIcon';
import ARText from '@audience-republic/arep-ui/dist/components/ARText';
import ARStateMessage from '@audience-republic/arep-ui/dist/components/ARStateMessage';
import ARSimpleButton from '@audience-republic/arep-ui/dist/components/ARSimpleButton';
import ARCheckbox from '@audience-republic/arep-ui/dist/components/ARCheckbox';
import ARLinkButton from '@audience-republic/arep-ui/dist/components/ARLinkButton';
import ARIconButton from '@audience-republic/arep-ui/dist/components/ARIconButton';
import ARInput from '@audience-republic/arep-ui/dist/components/ARInput';
import ARAutoCompleteInput from '@audience-republic/arep-ui/dist/components/ARAutoCompleteInput';
import ARTextarea from '@audience-republic/arep-ui/dist/components/ARTextarea';
import ARDateInput from '@audience-republic/arep-ui/dist/components/ARDateInput';
import ARMobileInput from '@audience-republic/arep-ui/dist/components/ARMobileInput';
import ARSnackbar from '@audience-republic/arep-ui/dist/components/ARSnackbar';
import ARField from '@audience-republic/arep-ui/dist/components/ARField';
import ARModal from '@audience-republic/arep-ui/dist/components/ARModal';
import ARSelect from '@audience-republic/arep-ui/dist/components/ARSelect';
import ARCountrySelect from '@audience-republic/arep-ui/dist/components/ARCountrySelect';
import ARStateSelect from '@audience-republic/arep-ui/dist/components/ARStateSelect';
import ARSimpleSelect from '@audience-republic/arep-ui/dist/components/ARSimpleSelect';
import ARDivider from '@audience-republic/arep-ui/dist/components/ARDivider';
import ARSimpleForm from '@audience-republic/arep-ui/dist/components/ARSimpleForm';
import ARSkeleton from '@audience-republic/arep-ui/dist/components/ARSkeleton';
import ARAvatar from '@audience-republic/arep-ui/dist/components/ARAvatar';
import ARFramedImage from '@audience-republic/arep-ui/dist/components/ARFramedImage';
import ARMultiSelect from '@audience-republic/arep-ui/dist/components/ARMultiSelect';
import ARSearch from '@audience-republic/arep-ui/dist/components/ARSearch';

Vue.use(ARStyle);
// Vue.use(ARNotification)
Vue.use(ARMediaQuery)
Vue.use(ARBrowser)
Vue.component('ArIcon', ARIcon)
Vue.component('ArFlagIcon', ARFlagIcon)
Vue.component('ArText', ARText)
Vue.component('ArStateMessage', ARStateMessage)
Vue.component('ArSimpleButton', ARSimpleButton)
Vue.component('ArCheckbox', ARCheckbox)
Vue.component('ArLinkButton', ARLinkButton)
Vue.component('ArIconButton', ARIconButton)
Vue.component('ArInput', ARInput)
Vue.component('ArAutoCompleteInput', ARAutoCompleteInput)
Vue.component('ArTextarea', ARTextarea)
Vue.component('ArDateInput', ARDateInput)
Vue.component('ArMobileInput', ARMobileInput)
Vue.component('ArSnackbar', ARSnackbar)
Vue.component('ArField', ARField)
Vue.component('ArModal', ARModal)
Vue.component('ArSelect', ARSelect)
Vue.component('ArCountrySelect', ARCountrySelect)
Vue.component('ArStateSelect', ARStateSelect)
Vue.component('ArSimpleSelect', ARSimpleSelect)
Vue.component('ArDivider', ARDivider)
Vue.component('ArSimpleForm', ARSimpleForm)
Vue.component('ArSkeleton', ARSkeleton)
Vue.component('ArAvatar', ARAvatar)
Vue.component('ArFramedImage', ARFramedImage)
Vue.component('ArMultiSelect', ARMultiSelect)
Vue.component('ArSearch', ARSearch)
